import { CreateTag } from '@ui/tags';
import { GearLinkSection } from './GearLinkSection';
import { OptionFilter } from '@periscopes/general/filters';
import { useTags } from '@hooks';

import { COPY_GENERIC, COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { memo, useCallback, useMemo, useState } from 'react';

export type TagSelectorParams = {
	filterByTags?: string;
};
export interface TagSelectorProps {
	onChange: (value: unknown) => void;
	value?: number;
}

export const TagSelector: React.FC<TagSelectorProps> = memo(({ onChange, value }) => {
	const tags = useTags();
	const [ open, setOpen ] = useState<boolean>();

	const sortedTags = useMemo(
		() =>
			tags.filter((tag) => !tag.autoTagged)
				.map((tag) => ({
					label: tag.name,
					value: tag.id
				})),
		[ tags ]
	);

	const handleOnFinish = useCallback((tagId: number) => {
		setOpen(false);
		setTimeout(() => setOpen(undefined));

		onChange(tagId);
	}, [ onChange ]);

	return (
		<GearLinkSection route={ FULL_ROUTES.TAGS_MANAGE }>
			<OptionFilter
				onChange={ onChange }
				open={ open }
				options={ sortedTags }
				placeholder={ COPY_GENERIC.SELECT(COPY_SPECIFIC.TAG) }
				popupRender={
					(menu) =>
						<>
							{ menu }
							<CreateTag onFinish={ handleOnFinish } />
						</>
				}
				value={ value } />
		</GearLinkSection>
	);
});
